import React from 'react';
import { Box, BoxProps, styled } from '@mui/material';

const StyledFormControlsWrapper = styled(Box)(({ theme }) => ({
    [theme.breakpoints.up("md")]: {
        display: "flex",
        flex: "0 0 50%",
        width: "100%",
        columnGap: "10px"
    },
}));

export const FormControlsWrapper: React.FC<{ children: React.ReactNode }> = (props) => {
    return (
        <StyledFormControlsWrapper>
            {props.children}
        </StyledFormControlsWrapper>
    );
};
